import { TreeNode, TreeNodeType } from ".";
import { StepItem } from "~/components/build/Show/components/Sidebar/TreeNode/StepItem";
import useCurrentJobOrStep from "~/components/build/Show/lib/useCurrentJobOrStep";
import { CommandStep, isFailed } from "~/lib/pipeline";

interface Props {
  step: CommandStep;
  depth?: number;
}

export function CommandStepItem(props: Props) {
  const { currentStep } = useCurrentJobOrStep();

  return (
    <StepItem
      {...props}
      active={props.step.uuid === currentStep?.uuid}
      failed={isFailed(props.step)}
    />
  );
}

export const createCommandStepNode = (step: CommandStep): TreeNode => ({
  id: step.uuid,
  type: TreeNodeType.StepCommand,
  render: (props) => <CommandStepItem step={step} {...props} />,
});
